$(document).ready(() => {
  if ($('.nav').length > 0) {
    // collapse all menu sections by default via js
    // so non-js users will still see contents
    $('.nav li ul').hide();
    if (location.href.match(/entertaining\/?$/) && $('.nav').length > 0) {
      $('.nav h4').each(function () {
        return $(this).parent().toggleClass('open');
      });
    }

    // bind click to toggle menu class
    $('.nav h4').click(function () {
      $(this).parent().toggleClass('open');
    });

    const url = location.href;
    const pagename = url.split('#')[0].split('?')[0].split('/').pop();

    // open submenu where this page belongs
    $(`.nav li li.${pagename}`).parent().parent().addClass('open');
    $(`.nav li li.${pagename}`).addClass('active');
  }
});
